import { useMemo } from "react";
import { isMountingCompatibleWithSuctionCup } from "3d/helpers";
import { useAppSelector, selectors } from "store";
import { useCollisionsContext } from "providers/collisions";
export var Warning;
(function (Warning) {
    Warning["INVALID_CUP"] = "invalid_cup";
    Warning["INVALID_PUMP"] = "invalid_pump";
    Warning["INVALID_CUP_MOUNTING"] = "invalid_cup_mounting";
    Warning["TAPE_COLLISION"] = "tape_collision";
    Warning["OUTSIDE_OBJECT"] = "outside_object";
})(Warning || (Warning = {}));
export var useNodeWarnings = function (node) {
    var nodeId = (node === null || node === void 0 ? void 0 : node.id) || "";
    var gripPositionHasCollision = useCollisionsContext().gripPositionHasCollision;
    var selectedCup = useAppSelector(selectors.selectSelectedCup(nodeId));
    var selectedCupMounting = useAppSelector(selectors.selectSelectedCupMounting(nodeId));
    var selectedPumpCentral = useAppSelector(selectors.selectSelectedCentralPump(nodeId));
    var selectedPumpDecentral = useAppSelector(selectors.selectSelectedDecentralPump(nodeId));
    var isCentralizedSystem = useAppSelector(selectors.selectIsCentralizedSystem);
    var nodeIsCollidingWithTape = selectedCup && gripPositionHasCollision(nodeId);
    var cupsOutsideOfObject = useAppSelector(selectors.selectCupsOutsideOfObject);
    var nodeIsOutsideObject = selectedCup && cupsOutsideOfObject.includes(nodeId);
    var nodeComponent = node === null || node === void 0 ? void 0 : node.component;
    var warnings = useMemo(function () {
        var allWarnings = [];
        if (selectedCup && nodeComponent) {
            if (!selectedCup.valid) {
                allWarnings.push(Warning.INVALID_CUP);
            }
        }
        if (!isCentralizedSystem &&
            selectedPumpDecentral &&
            !selectedPumpDecentral.valid) {
            allWarnings.push(Warning.INVALID_PUMP);
        }
        if (isCentralizedSystem &&
            selectedPumpCentral &&
            !selectedPumpCentral.valid) {
            allWarnings.push(Warning.INVALID_PUMP);
        }
        if ((selectedCupMounting && !selectedCupMounting.valid) ||
            !isMountingCompatibleWithSuctionCup(selectedCup, selectedCupMounting)) {
            allWarnings.push(Warning.INVALID_CUP_MOUNTING);
        }
        if (nodeIsCollidingWithTape) {
            allWarnings.push(Warning.TAPE_COLLISION);
        }
        if (nodeIsOutsideObject) {
            allWarnings.push(Warning.OUTSIDE_OBJECT);
        }
        return allWarnings;
    }, [
        selectedCup,
        nodeComponent,
        isCentralizedSystem,
        selectedPumpDecentral,
        selectedPumpCentral,
        selectedCupMounting,
        nodeIsCollidingWithTape,
        nodeIsOutsideObject,
    ]);
    return warnings;
};
